import React from 'react';
import { InputRef } from 'antd'; // Only to use type
import MyBrokerageContext from '../MyBrokerageContext';
import ListingsSearch from './ListingsSearch';
import OpenHousesSearch from './OpenHousesSearch';
import HavesWantsSearch from './HavesWantsSearch';

const Search: React.FC = () => {
  const {
    queryData: { type: tab },
  } = React.useContext(MyBrokerageContext);
  const searchElementRef: React.Ref<InputRef> = React.useRef();

  React.useEffect(() => {
    if (searchElementRef.current) {
      (searchElementRef.current as any).focus();
    }
  }, [tab, searchElementRef.current?.input]);

  if (tab === 'listings') return <ListingsSearch ref={searchElementRef} />;
  if (tab === 'openHouses') return <OpenHousesSearch ref={searchElementRef} />;
  return <HavesWantsSearch ref={searchElementRef} />;
};

export default Search;
